import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";
import "../../css/Tabss.css"

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import whiteImage from "../../assets/images/icons/white+.svg"
import Plus_orange_Vector from '../../assets/images/icons/Plus_orange_Vector.svg'

import SearchIcon from "../../assets/images/all/search.svg";

import CommanInstitute from '../../components/CommanInstitute';
import Group from '../../assets/images/icons/Group 85.svg'
import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg'
import UpImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 3.svg'
import prime_file from '../../assets/images/icons/prime_file-pdf.svg'


const InstituteWelcome = (props) => {

    const navigate = useNavigate();



    /// Stream end
    // console.log("streamDetailsstreamDetails", managers)
    return (
        <div className="bg_dashboard">

            <div className="container">
                <div className="row">

                    <CommanInstitute />


                    <div class="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                    <div className="row mt-5">
                    <div className="col-md-9 ps-0">
                        <div className="search-box dashboard_search">
                            <input type="text"
                                className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                placeholder="Search"/>
                            <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                    src={SearchIcon} alt="" /></button>
                        </div>
                    </div>
                    <div className="col-md-2 text-xl-center  mt-3">
                        <img src={NotificationIcon} alt="" />
                    </div>
                    <div className="col-md-1">
                        <div className="dashboard_profile ms-auto">
                            <img src={ProfileImage} alt=""/>
                        </div>
                    </div>
                </div>


               
                <div class="row px-0 py-3">
                    <div class="col-sm-12">
                        <h2 class="learm-tilte">Welcome Message</h2>
                        <p>Start putting together your course by creating sections, lectures and practice activities
                            (quizzes, coding exercises and assignments).</p>
                        <p>Use your course outline to structure your content and label your sections and lectures
                            clearly. If you're intending to offer your course for free, the total length of video
                            content must be less than 2 hours.</p>
                    </div>
                </div>

                <div class="row p-0 mt-1">
                    <div class="dashboard_card p-0">
                 
                        <div class="row px-0 px-sm-3">
                            <div class="col-sm-12">
                                <div class="dashboard_card p-4">
                                 
                                    <label for="courseDescription" class="profile_text_2 mb-3">Course
                                        Description</label>
                                    <div class="position-relative">
                                        <textarea class="common-input common-input--md dash_borad_input_1"
                                            id="courseDescription"  style={{
                                                height: '300px',
                                              }}
                                            placeholder="Simply dummy text of the printing and typesetting industry..."
                                            maxlength="300"></textarea>
                                        <span class="character-count position-absolute"
                                             style={{
                                                right: '10px',
                                                bottom: '10px',
                                                position: 'absolute', // Required for `right` and `bottom` to work
                                              }}>1000</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="row p-0 mt-3">
                    <div class="dashboard_card p-0">
                       
                        <div class="row px-0 px-sm-3">
                            <div class="col-sm-12">
                                <div class="dashboard_card p-4">
                                  
                                    <label for="courseDescription" class="profile_text_2 mb-3">Congratulations Message</label>
                                    <div class="position-relative">
                                        <textarea class="common-input common-input--md dash_borad_input_1"
                                            id="courseDescription"  style={{
                                                height: '300px',
                                              }}
                                            placeholder="Simply dummy text of the printing and typesetting industry..."
                                            maxlength="300"></textarea>
                                        <span class="character-count position-absolute"
                                             style={{
                                                right: '10px',
                                                bottom: '10px',
                                                position: 'absolute', // Required for `right` and `bottom` to work
                                              }}>1000</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

             
                <div class="row mb-5 mt-3">
                    <div class="col-sm-12 d-flex justify-content-between">
                        <span class="learm-tilte2 font-16" onClick={() => navigate("/InstitutePromotion")}><img
                            src={downArrowImage} alt="" /> Previous</span>
                        <span class="learm-tilte2 font-16" onClick={()=>alert("complete all screen ")}>Next <img
                            src={UpImage} alt="" /></span>
                    </div>
                </div>



            </div>
                </div>

            </div>






            {/* Footer */}
            <Footer />
        </div>
    );
};

export default InstituteWelcome






